<template>
  <v-card>
    <v-card-text class="v-card__text">
        <h3 class="headline mb-0">{{$t("penalities.title")}}</h3>
        <v-data-table
            :headers="headers"
            :items="this.items"
            must-sort hide-default-headers>
        <template slot="items" slot-scope="props">
          <td><a @click="showDialog(props.item)">{{props.item.penality.title}}</a></td>
          <td>{{props.item.penality.penalityString}}</td>
          <td>{{props.item.amount}}</td>
          <td>{{props.item.totalAdditionalTime}}</td>
          <td><v-btn icon v-on:click="remove(props.item.id)"><v-icon color="red">cancel</v-icon></v-btn></td>
        </template>
      </v-data-table>
    </v-card-text>
    <v-card-actions>
        <v-btn @click="showDialog({amount: 1})" color="success">
        {{ $t("ctrl.add") }}
        </v-btn>
    </v-card-actions>
    <RunPenality ref="dialog" :reload="this.reload" />
    <v-dialog v-model="removeDialog" persistent max-width="390">
      <v-card>
        <v-card-title class="v-card__title headline">{{ $t('penalities.removeConfirmText') }}</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error darken-1" @click="removeDialog = false">{{ $t('ctrl.close') }}</v-btn>
          <v-btn color="success darken-1" @click="removeConfirm()">{{ $t('ctrl.remove') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
  import {
    VCard,
    VTooltip,
    VForm,
    VTextField,
    VCardActions,
    VCardText,
    VSelect,
    VDataTable,
    VDatePicker,
    VDialog
  } from 'vuetify/lib'
  import RunPenality from '../../dialogs/RunPenality'
  import fccapi from '../../fccapi'

  export default {
    name: 'FCCRunPenalities',
    data: function(){
        return {
            items: [],
            removeDialog: false,
            removeId: -1
        }
    },
    computed: {
      genders: function () { 
        return [this.$t("profile.male"), this.$t("profile.female")]
      },
        selectedCompetition: function() {
            return this.$store.getters['competitionId'];
        },
        headers: function(){
            return [
                { text: this.$t("penalities.description"), value: "penalities.title"},
                { text: this.$t("penalities.penalityString"), value: "penalities.penalityString"},
                { text: this.$t("penalities.amount"), value: "amount"},
                { text: this.$t("penalities.totalAdditionalTime"), value: "totalAdditionalTime"},
                { text: this.$t("ctrl.remove"), value: ""},
            ];
        }
    },
    methods: {
        applicationType: function(i) {
            return this.$t('application.'+Array('individual', 'tandem', 'relay')[i]);
        },
        reload: function(){
            fccapi.get(`runs/${this.$route.params.id}/penalities`).then(d=>{
                this.items = d.data
            })
        },
        showDialog: function(id){
          this.$refs.dialog.show(id);
        },
        remove: function(id){
          this.removeId = id;
          this.removeDialog = true;
        },
        removeConfirm: function(){
          fccapi.delete('run-penalities/'+this.removeId).then(d => {
            this.removeDialog = false;
            this.reload();
          })
        }
    },
    mounted: function(){
        this.reload();
    },
    watch: {
        selectedCompetition() {
            console.log("changed")
            this.reload();
        }
    },
    components: {
        VCard,
        VTooltip,
        VForm,
        VTextField,
        VCardActions,
        VCardText,
        VSelect,
        VDataTable,
        VDatePicker,
        RunPenality,
        VDialog
    },    
  }
</script>